import { NewsCreate, NewsBannerCreate } from "./NewsCreate";
import { NewsList, NewsBannerList } from "./NewsList";
import { NewsEdit, NewsEditStatus, NewsBannerEdit, NewsBannerEditStatus } from "./NewsEdit";
import { NewsDetail, NewsBannerDetail } from "./NewsDetail";

import { BannerList } from "./BannerList";
import { BannerCreate } from "./BannerCreate";
import { BannerEdit } from "./BannerEdit";

import * as urls from "./urls";
import { RestrictedPage } from 'routes/CrudRoute';


const NewsResourceName = "Website Blog";
const NewsBannerResourceName = "Banner News";
const BannerResourceName = "In-App Banner";


export const NewsResources = [
  {
    "name": BannerResourceName,
    "frontendPath": urls.bannerFrontendPath,
    "backendPath": urls.bannerBackendPath,
    "list": BannerList,
    "create": BannerCreate,
    "edit": BannerEdit,
    "showInSideMenu": true,
  },
  {
    "name": NewsBannerResourceName,
    "frontendPath": urls.newsBannerFrontendPath,
    "backendPath": urls.newsBannerBackendPath,
    "list": NewsBannerList,
    "create": NewsBannerCreate,
    "show": NewsBannerDetail,
    "showInSideMenu": true,
  },
  {
    "name": NewsResourceName,
    "frontendPath": urls.newsFrontendPath,
    "backendPath": urls.newsBackendPath,
    "list": NewsList,
    "create": NewsCreate,
    "show": NewsDetail,
    "showInSideMenu": true,
  },
];

export const NewsCustomRoutes = [
  {
    "name": "Edit News Content",
    "frontendPath": urls.newsEditFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(NewsEdit, "edit news content", {
      "resource": NewsResourceName,
      "redirectPath": urls.newsFrontendPath,
    })
  },
  {
    "name": "Edit News Status",
    "frontendPath": urls.newsEditStatusFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(NewsEditStatus, "edit news status", {
      "resource": NewsResourceName,
      "redirectPath": urls.newsFrontendPath,
    })
  },
  {
    "name": "Edit Banner News Content",
    "frontendPath": urls.newsBannerEditFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(NewsBannerEdit, "edit banner news content", {
      "resource": NewsBannerResourceName,
      "redirectPath": urls.newsBannerFrontendPath,
    })
  },
  {
    "name": "Edit Banner News Status",
    "frontendPath": urls.newsBannerEditStatusFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(NewsBannerEditStatus, "edit banner news status", {
      "resource": NewsBannerResourceName,
      "redirectPath": urls.newsBannerFrontendPath,
    })
  }
];


// WEBPACK FOOTER //
// ./src/routes/news/resources.js